import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter037() {
  return <KbChapterPage slug="chapter-037" />;
}

(Chapter037 as unknown as { path: string }).path = "/theory-album/037";
